export default __webpack_public_path__ + "static/media/assembly.f0929d40.svg";